exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pf-l-bullseye {\n  --pf-l-bullseye--Padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: var(--pf-l-bullseye--Padding);\n  margin: 0; }\n", ""]);

